<template>
    <div>
        <v-btn
            :class="'utility-nav-btn ' + (btnFields && btnFields.backgroundColor ? btnFields.backgroundColor:'dorange')"
            depressed
            @click="btnClick()"
            @mouseover.native="isHover = true"
            @mouseleave.native="isHover = false"
        >
            {{ btnFields ? btnFields.label : '' }}
        </v-btn>
        <external-link-dialog
            v-if="btnFields && btnFields.externalLink"
            :link="btnFields.externalLink"
            :dialog="dialog"
            @close="dialog = false"
        />
        <email-dialog
            v-if="btnFields && btnFields.type === 'Download Guide'"
            v-model="downloadGuideModal"
            is-download
            @download="downloadAsset()"
        />
        <Submenu
          v-if="btnFields && btnFields.dropdownContent && !smAndDown"
          :content="btnFields.dropdownContent"
          :linkHover="isHover"
          :activeMenu="activeMenu"
          @open-dropdown="bubbleEvent"
        >
        </Submenu>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import BtnMixin from '@/mixins/btn-mixin'
import ExternalLinkDialog from '@/components/dialogs/external-link-dialog'
import EmailDialog from '@/components/dialogs/email-dialog'
import Submenu from '@/components/core/submenu'

export default {
  name: 'UtilityNavBtn',
  components: { ExternalLinkDialog, EmailDialog, Submenu },
  props: {
    activeMenu: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      dialog: false,
      isHover: false
    }
  },
  computed: {
    ...mapState({ siteConfig: (state) => state.site.siteConfig }),
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    },
    hoverClass () {
      if (!this.isHover) {
        return ''
      }
      return this.siteConfig.secondaryColor === 'dark blue'
        ? 'info--text'
        : 'secondary--text'
    },
    mobileClass () {
      if (!this.smAndDown) {
        return ''
      }
      return this.siteConfig.secondaryColor === 'dark blue'
        ? 'info--text'
        : 'secondary--text'
    }
  },
  methods: {
    // backgroundColorClass,
    handleClick () {
      if (this.loading) {
        return
      }
      this.btnClick() // see BtnMixin
    },
    close () {
      this.dialog = false
    },
    bubbleEvent (model) {
      this.$emit('open-dropdown', model)
      // this method also exists in ctf-link.vue
      // https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
      const els = document.getElementsByClassName('dropdown-menu container')
      Array.prototype.forEach.call(els, el => {
        if (!this.isElementInViewport(el)) {
          el.style.right = 0
        } else {
          el.style.right = 'initial'
        }
      })
    },
    isElementInViewport (el) {
      el.style.right = 'initial' // check if its initial position is in viewport
      var rect = el.getBoundingClientRect()
      const isInviewPort = (
        rect.right <= (window.innerWidth || document.documentElement.clientWidth))
      return isInviewPort
    }
  },
  mixins: [BtnMixin]
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';
.utility-nav-btn:focus{
  outline: 5px auto;
  outline-offset: 4px;
  outline: solid black;
}

.utility-nav-btn:active{
  outline: 5px auto;
  outline-offset: 4px;
  outline: solid black;
}

.utility-nav-btn {
    height: 25px !important;
    margin: 10px;
    font-size: 12px;

    &.v-btn {
        border-radius: 0px !important;
        border: 2px solid transparent;
        ::v-deep span {
            color: $white !important;
        }
        &:hover {
            background-color: $white !important;
            border: 2px solid $dorange !important;
            ::v-deep span {
                color: $dorange !important;
            }
        }
    }
    &.dorange {
      &:hover {
        background-color: $white !important;
        border: 2px solid $dorange !important;
        ::v-deep span {
          color: $dorange !important;
        }
      }
    }

    &.gray {
      background-color: $gray !important;
      &:hover {
        background-color: $white !important;
        border: 2px solid $black !important;
        ::v-deep span {
          color: $black !important;
        }
      }
    }

    &.orange {
      background-color: $dorange !important;
      &:hover {
        background-color: $white !important;
        border: 2px solid $dorange !important;
      }
    }

    &.gold {
      background-color: $gold !important;
      color: white !important;
      &:hover {
        background-color: $white !important;
        border: 2px solid $gold !important;
        ::v-deep span {
          color: $black !important;
        }
      }
    }

    &.blue {
      background-color: $primary !important;
      color: white !important;
      &:hover {
        background-color: $white !important;
        border: 2px solid $primary !important;
        ::v-deep span {
          color: $primary !important;
        }
      }
    }

    &.white {
      background-color: $white !important;
      border: 2px solid $black !important;
      ::v-deep span {
        color: $black !important;
      }
      &:hover {
        background-color: $gray !important;
        border: 2px solid $white !important;
        ::v-deep span {
          color: $white !important;
      }
      }
    }
    &.purple {
      background-color: $warning !important;
      &:hover {
        background-color: $white !important;
        border: 2px solid $warning !important;
        ::v-deep span {
          color: $warning !important;
        }
      }

    }
    z-index: 255;
}
.link {
    display: block;
    color: $white;
}

.router-link-active-info {
    position: relative;
    color: $info !important;
    .primary--text {
        color: $info !important;
    }
    .info--text {
        color: $primary !important;
    }
}
.router-link-active-secondary {
    color: $secondary !important;
    .primary--text {
        color: $secondary !important;
    }
    .secondary--text {
        color: $primary !important;
    }
}
.v-list-item {
    border: 1px solid transparent !important;
    &:focus {
        border: 1px solid $secondary !important;
    }
}
a {
    text-decoration: none;
}
.ctf-utility-nav-link {
    position: relative;
}
.ctf-utility-nav-link:hover {
    text-decoration: underline !important;
}
</style>
